// @flow
import ErrorResponse from "../../models/error/ErrorResponse";

import { replace } from "../_router/RouterActions";
import { logoutSuccess } from "./SignOut";

import Cache from "../../utils/browser/Cache";

import { removeModelByKey } from "../_modularui/ModularUIActions";
import { getApplication } from "../_modularui/ModularUISelectors";
import { noAction, reloadApplication } from "./Application";
import { sendAuthenticationError } from "./SignIn";

import { getSetting } from "../../constants";

import type { ThunkAction } from "../types";

/**
 */
export const handleUnauthorized =
  (errorResponse: ErrorResponse): ThunkAction<> =>
  (dispatch, getState) => {
    const finish = () => {
      dispatch(logoutSuccess());
      Cache.removeItem("auth");

      if (errorResponse.isInvalidUsername) {
        dispatch(sendAuthenticationError(errorResponse.message));
      }

      const state = getState();
      const location = state.router.location;
      const LOGIN_PATH = getSetting("LOGIN_PATH", "/signin");

      if (location?.pathname !== LOGIN_PATH) {
        const locationFrom = location?.state?.from;
        return dispatch(
          replace(LOGIN_PATH, {
            from: locationFrom ?? state.router.location,
            modal: false,
          }),
        );
      }

      return dispatch(noAction());
    };

    if (errorResponse.connectKey) {
      dispatch(removeModelByKey(errorResponse.connectKey));
    }

    if (
      getSetting("PAGE_RELOAD_ON_UNAUTHORIZED_ERROR", false) &&
      errorResponse.response?.error
    ) {
      // $FlowIssue
      globalThis.location.reload();
      return;
    }

    const application = getApplication(getState());
    const shouldReload = Cache.getItem("auth") || application?.isLoggedIn;

    return shouldReload ? dispatch(reloadApplication()).then(finish) : finish();
  };
